import { Theme } from "@mui/material/styles";

import { misc, neutral } from "app/themes/colors";

export const getTabsComponents = (sunoTheme: Theme) => ({
  MuiTabs: {
    styleOverrides: {
      root: {
        borderBottom: "1px solid #E0E0E0",
        "& .MuiTabs-indicator": {
          // #C79AEB measured 2.19:1 against white, under the 3:1 a non-text indicator needs to
          // carry meaning. The brand purple clears it comfortably.
          backgroundColor: misc.suno,
          height: 3
        }
      }
    }
  },
  MuiTabPanel: {
    styleOverrides: {
      root: {
        padding: 0
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        // 18px with 20px of side padding made twelve tabs need ~2,100px of a ~1,076px bar, so
        // Practice Settings hid seven of them behind a scroll chevron. MUI's own default is 14px.
        color: neutral[800],
        fontSize: sunoTheme.typography.pxToRem(14),
        lineHeight: sunoTheme.typography.pxToRem(20),
        paddingTop: sunoTheme.spacing(1),
        paddingBottom: sunoTheme.spacing(1),
        paddingLeft: sunoTheme.spacing(1.5),
        paddingRight: sunoTheme.spacing(1.5),
        // MUI reserves 90px per tab at md+, which alone floors twelve tabs at 1,080px.
        minWidth: 0,
        textTransform: "none",
        // Held constant across states on purpose: a tab that bolds on selection gets wider, which
        // reflows the row and can push the last tab out of view. The selected state is carried by
        // the fill and the indicator instead.
        fontWeight: 600,
        "&:hover": {
          backgroundColor: misc.lavenderMist,
          color: neutral[900]
        },
        "&.Mui-selected": {
          // Was neutral[900] on both states — selected and unselected were the same colour, and
          // the only cue was the weight change above. The step is carried by the fill and the
          // indicator rather than by dimming the unselected tabs: neutral[700] would have given a
          // bigger contrast step but measures 4.03:1 on white, under AA for 14px text.
          color: misc.suno,
          backgroundColor: misc.lightLavender,
          borderRadius: "6px 6px 0 0",
          letterSpacing: 0
        }
      }
    }
  }
});
